import { t } from 'i18next';
import React from 'react';
import ReactSelect, {
  SelectComponentsConfig,
  StylesConfig,
  OnChangeValue,
  MultiValue,
  SingleValue,
  GroupBase,
  InputActionMeta,
} from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';

import { MReactSelectOption } from './MSelect.model';
import classes from './MSelect.module.scss';

type Props<IsMulti extends boolean = false> = {
  placeholder?: string;
  name?: string;
  invalid?: boolean;
  className?: string;
  disabled?: boolean;
  styles: StylesConfig<MReactSelectOption, IsMulti>;
  isMulti?: IsMulti;
  value: IsMulti extends true ? MultiValue<MReactSelectOption> : SingleValue<MReactSelectOption>;
  closeMenuOnSelect: boolean;
  hideSelectedOptions?: boolean;
  components: SelectComponentsConfig<MReactSelectOption, IsMulti, GroupBase<MReactSelectOption>>;
  options: MReactSelectOption[];
  isDisabled?: boolean;
  isClearable?: boolean;
  isCreatable?: boolean;
  isLoading?: boolean;
  inputValue?: string;
  fixOverflow?: boolean;
  stopPropagation?: boolean;
  onChange?: (value: OnChangeValue<MReactSelectOption, IsMulti>) => void;
  onCreateOption?: (value: string) => void;
  onInputChange?: (value: string, actionMeta: InputActionMeta) => string | void;
  shiftKeyDown: () => void;
  shiftKeyUp: () => void;
};

const MSelectView = <IsMulti extends boolean>(props: Props<IsMulti>): JSX.Element => {
  const selects = props.isCreatable ? (
    <ReactSelectCreatable
      className={classes['field']}
      placeholder={props.placeholder}
      name={props.name}
      styles={props.styles}
      isMulti={props.isMulti}
      value={props.value}
      isDisabled={props.disabled}
      closeMenuOnSelect={props.closeMenuOnSelect}
      hideSelectedOptions={props.hideSelectedOptions}
      components={props.components}
      isClearable={props.isClearable}
      options={props.options}
      isLoading={props.isLoading}
      inputValue={props.inputValue}
      onChange={props.onChange}
      onCreateOption={props.onCreateOption}
      onInputChange={props.onInputChange}
    ></ReactSelectCreatable>
  ) : (
    <div
      onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => event.key === 'Shift' && props.shiftKeyDown()}
      onKeyUp={(event: React.KeyboardEvent<HTMLDivElement>) => event.key === 'Shift' && props.shiftKeyUp()}
    >
      <ReactSelect
        className={classes['field']}
        placeholder={props.placeholder}
        name={props.name}
        styles={props.styles}
        isMulti={props.isMulti}
        value={props.value}
        isDisabled={props.disabled}
        closeMenuOnSelect={props.closeMenuOnSelect}
        hideSelectedOptions={props.hideSelectedOptions}
        isClearable={props.isClearable}
        options={props.options}
        isLoading={props.isLoading}
        inputValue={props.inputValue}
        onChange={props.onChange}
        onInputChange={props.onInputChange}
        noOptionsMessage={() => t('common.noOptions')}
      ></ReactSelect>
    </div>
  );

  return props.fixOverflow ? (
    <div className={`${classes['parent']} ${props.className ? props.className : ''}`}>
      <div className={classes['fixed-wrapper']}>
        <div className={classes['fixed']}>{selects}</div>
      </div>
    </div>
  ) : (
    <div className={props.className} onClick={props.stopPropagation ? (event) => event.stopPropagation() : undefined}>
      {selects}
    </div>
  );
};

MSelectView.displayName = 'MSelectView';
MSelectView.defaultProps = {};

export default MSelectView;
